import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import AboutMe from "./components/AboutMe";
import GameHighlights from "./components/GameHighlights";
import SocialMedia from "./components/SocialMedia";
import Gallery from "./components/Gallery";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="bg-urban-dark min-h-screen font-rajdhani">
      <Navbar />
      <Hero />
      <AboutMe />
      <GameHighlights />
      <SocialMedia />
      <Gallery />
      <Contact />
      <Footer />
    </div>
  );
}
